import React from 'react';
import NorthEastIcon from '@mui/icons-material/NorthEast';

export default function DashboardCard({ title, value, percentage = "+129%" }) {
  return (
    <div className='w-full flex flex-col gap-5 p-5 bg-[#191919] rounded-2xl'>
      <h2 className="text-4xl font-medium m-0">{title}</h2>
      <div className="flex gap-2">
        <div className="p-2 flex justify-center items-center rounded-lg bg-[rgb(var(--global-color-primary))] h-10 w-10">
          <NorthEastIcon sx={{ color: "black", fontSize: "2rem" }} />
        </div>
        <div className="flex flex-col gap-2">
          {/*<span className="font-semibold p-1 px-3 bg-green-900 text-green-500 flex rounded-full w-fit">{percentage}</span>*/}
          <div className="font-bold text-4xl">{value !== null ? value : "-"}</div>
        </div>
      </div>
    </div>
  );
}
